import { AceEditorTheme } from 'modules/aceEditor/types';
import { useManageBeeCustomFonts } from 'modules/campaigns/lib/hooks/useManageBeeCustomFonts';
import { FC, useState } from 'react';
import { useLocalStorage } from 'utils/hooks/useLocalStorage';
import { prefixWithUserProject } from 'utils/indexPageUtils';
import {
  ContentEditorPreferencesContext,
  ContentEditorPreferencesContextState,
} from './ContentEditorPreferencesContext';

export const ContentEditorPreferencesProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedSideBySideTheme, setSelectedSideBySideTheme] = useLocalStorage(
    prefixWithUserProject('template-edit-side-by-side-theme'),
    AceEditorTheme.Monokai,
  );

  const toggleModal = (isOpen?: boolean) => {
    setIsModalOpen(isOpen ?? !isModalOpen);
  };

  const {
    customFonts,
    customFontsError,
    isFetchingCustomFonts,
    getCustomFonts,
    addCustomFont,
    editCustomFont,
    deleteCustomFont,
  } = useManageBeeCustomFonts();

  const context: ContentEditorPreferencesContextState = {
    addCustomFont,
    customFonts,
    customFontsError,
    deleteCustomFont,
    editCustomFont,
    getCustomFonts,
    isModalOpen,
    isFetchingCustomFonts,
    selectedSideBySideTheme,
    setSelectedSideBySideTheme,
    toggleModal,
  };

  return (
    <ContentEditorPreferencesContext.Provider value={context}>
      {children}
    </ContentEditorPreferencesContext.Provider>
  );
};
